// extracted by mini-css-extract-plugin
export default {"tabBar":"styles_tabBar__mk6Al"};